import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Reusable Breadcrumb component
 * @param {Array} items - Array of {label, href} objects
 */
export const Breadcrumb = ({ items = [] }) => {
  if (!items || items.length === 0) return null;

  return (
    <nav className="flex items-center gap-2 text-sm text-[#6B7280] mb-4" aria-label="Breadcrumb">
      <Link to="/" className="hover:text-[#1E40AF] transition-colors">
        Home
      </Link>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <span className="text-[#9CA3AF]">/</span>
          {index === items.length - 1 ? (
            <span className="text-[#111827] font-medium truncate max-w-[200px]">
              {item.label}
            </span>
          ) : (
            <Link 
              to={item.href} 
              className="hover:text-[#1E40AF] transition-colors truncate max-w-[150px]"
            >
              {item.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;
